module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }